import { render } from "./SubmissionForm.vue?vue&type=template&id=80748f82&scoped=true"
import script from "./SubmissionForm.vue?vue&type=script&lang=js"
export * from "./SubmissionForm.vue?vue&type=script&lang=js"

import "./SubmissionForm.vue?vue&type=style&index=0&id=80748f82&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80748f82"]])

export default __exports__